import { createQuestionFromConfiguration } from '../../../logbook/views/QuestionView';
import {
    Card,
    Exercise,
    LabelBody,
    LabelHeader4,
    LabelHeader5,
    SecondaryButton,
    Spacer,
    Textarea,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { IllustrationPenPaper, IllustrationScribbling } from '../../icons';
import { ExerciseStatus } from '../../interfaces';
import { useSyncedState } from '../../useSyncedState';

const reflectionsKey = 'reflections';

export const exerciseData15: ExerciseData = {
    ExerciseView: Module1Exercise5,
    dataKeys: [reflectionsKey],
    questions: [
        createQuestionFromConfiguration({
            title: 'Mine refleksioner',
            description: (
                <>
                    <LabelBody>
                        Er der noget, som er særligt vigtigt for dig at dele med
                        din psykolog om din baggrund eller nuværende
                        livssituation?
                    </LabelBody>
                    <LabelBody className="my-10">
                        Har nogen af de første øvelser givet anledning til, at
                        der er noget du gerne vil vende?
                    </LabelBody>
                    <LabelBody>
                        Er du mest til at psykologen lytter, giver råd eller
                        spørger til noget bestemt?
                    </LabelBody>
                </>
            ),
            dataKeys: [reflectionsKey],
        }),
    ],
};

function Module1Exercise5({ exercise, onContinue }: ExerciseViewProps) {
    const [reflections, setReflections] = useSyncedState(
        exercise.Data[reflectionsKey],
    );
    return (
        <Exercise title="Forberedelse til din samtale">
            <LabelHeader4>
                Forbered dig til din samtale med psykologen
            </LabelHeader4>
            <LabelBody className="my-10">
                Du skal snart have første samtale med din psykolog. Hvis du har
                lyst, kan det være en god idé inden samtalen at overveje nogle
                ting, som du gerne vil fortælle psykologen om.
            </LabelBody>
            <LabelBody>
                Der er intet krav om, at du forbereder dig. Så skriv blot ned,
                hvis du har lyst og kan overskue det. Det er også helt
                almindeligt, hvis du er en smule nervøs. Husk på, at du selv
                bestemmer hvor meget du vil dele.
            </LabelBody>
            <IllustrationScribbling className="mx-auto my-30" />
            <Card>
                <IllustrationPenPaper />
                <LabelHeader5 className="mb-10 mt-20">
                    Mine refleksioner
                </LabelHeader5>
                <LabelBody>
                    Er der noget, som er særligt vigtigt for dig at dele med din
                    psykolog om din baggrund eller nuværende livssituation?
                </LabelBody>
                <LabelBody className="my-10">
                    Har nogen af de første øvelser givet anledning til, at der
                    er noget du gerne vil vende?
                </LabelBody>
                <LabelBody>
                    Er du mest til at psykologen lytter, giver råd eller spørger
                    til noget bestemt?
                </LabelBody>
                <Textarea text={reflections} onChangeText={setReflections} />
                <LabelBody>
                    Dit svar bliver gemt i logbogen, når du fortsætter.
                </LabelBody>
            </Card>
            <Spacer className="mt-30" />
            <SecondaryButton
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                        data: { [reflectionsKey]: reflections },
                    })
                }
            >
                Afslut
            </SecondaryButton>
        </Exercise>
    );
}
